import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { TaxListPage } from "@/modules/billing";
import { requireSuperAdmin } from "@/utils";

const taxSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1)
});

export const Route = createFileRoute("/billing/tax/")({
  validateSearch: zodValidator(taxSearchSchema),
  beforeLoad: requireSuperAdmin,
  component: () => (
    <>
      <DocumentTitle
        title="Tax"
        description="Review tax summaries, manage active subscriptions, and track billing details."
      />
      <TaxListPage />
    </>
  )
});
